// import { cloneDeep } from 'lodash';
import * as constants from '@/common/constants';

export default {
    state: {
        visitedViews: [],
        cachedViews: []
    },
    mutations: {
        [constants.VUEX_MUTATIONS_TAGS_VIEW_ADD]: (state, view) => {
            if (state.visitedViews.some(v => v.path === view.path)) {
                return;
            }
            try {
                let tmp = (view);
                tmp.meta.title = tmp.meta.title || '';
                state.visitedViews.push(tmp);
            } catch (error) {
                console.error('导航缓存异常：%s', error);
            }
        },
        [constants.VUEX_MUTATIONS_TAGS_VIEW_DELETE]: (state, view) => {
            for (const [i, v] of state.visitedViews.entries()) {
                if (v.path === view.path) {
                    state.visitedViews.splice(i, 1);
                    break;
                }
            }
        },
        [constants.VUEX_MUTATIONS_TAGS_VIEW_DELETE_OTHER]: (state, view) => {
            for (const [i, v] of state.visitedViews.entries()) {
                if (v.path === view.path) {
                    state.visitedViews = [v];
                    break;
                }
            }
        }
    },
    actions: {
        /** 将打开的页面，放到缓存中 */
        [constants.VUEX_ACTIONS_TAGS_VIEW_ADD] ({ dispatch, commit }, view) {
            dispatch('addVisitedView', view);
        },
        addVisitedView ({ commit }, view) {
            commit(constants.VUEX_MUTATIONS_TAGS_VIEW_ADD, view);
        },
        [constants.VUEX_ACTIONS_TAGS_VIEW_DELETE] ({ commit, state }, view) {
            return new Promise(resolve => {
                commit(constants.VUEX_MUTATIONS_TAGS_VIEW_DELETE, view);
                resolve([...state.visitedViews]);
            });
        },
        [constants.VUEX_ACTIONS_TAGS_VIEW_DELETE_OTHER] ({ commit, state }, view) {
            return new Promise(resolve => {
                commit(constants.VUEX_MUTATIONS_TAGS_VIEW_DELETE_OTHER, view);
                resolve([...state.visitedViews]);
            });
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/modules/store-tags-view.js